import { create } from 'zustand'
import type { GetFreeShippingRatesQuery } from '@/gql/graphql'

export type FreeShippingRate = GetFreeShippingRatesQuery['freeShippingRates'][number]

export interface ChannelStore {
  channelId: string | undefined
  shopIsPublic: boolean
  googleTagManagerId: string | undefined
  availableLanguageCodes: string[]
  defaultLanguageCode: string | undefined
  currentLanguageCode: string | undefined
  deliveryDays: number | null | undefined
  pricesIncludeTax: boolean
  freeShippingRates: FreeShippingRate[]
  setChannelId: (channelId: string) => void
  setShopIsPublic: (shopIsPublic: boolean) => void
  setGoogleTagManagerId: (id: string) => void
  setAvailableLanguageCodes: (codes: string[]) => void
  setDefaultLanguageCode: (code: string | undefined) => void
  setCurrentLanguageCode: (code: string) => void
  setDeliveryDays: (days: number | null | undefined) => void
  setPricesIncludeTax: (pricesIncludeTax: boolean) => void
  setFreeShippingRates: (rates: FreeShippingRate[]) => void
}

export const useChannelStore = create<ChannelStore>((set) => ({
  channelId: undefined,
  shopIsPublic: false,
  googleTagManagerId: undefined,
  availableLanguageCodes: [],
  defaultLanguageCode: undefined,
  currentLanguageCode: undefined,
  deliveryDays: undefined,
  pricesIncludeTax: true,
  freeShippingRates: [],
  setChannelId: (channelId: string) => {
    set(() => ({
      channelId,
    }))
  },
  setShopIsPublic: (shopIsPublic: boolean) => {
    set(() => ({
      shopIsPublic,
    }))
  },
  setGoogleTagManagerId: (id: string) => {
    set(() => ({
      googleTagManagerId: id,
    }))
  },
  setAvailableLanguageCodes: (codes: string[]) => {
    set(() => ({
      availableLanguageCodes: codes,
    }))
  },
  setDefaultLanguageCode: (code: string | undefined) => {
    set(() => ({
      defaultLanguageCode: code,
    }))
  },
  setCurrentLanguageCode: (code: string) => {
    set(() => ({
      currentLanguageCode: code,
    }))
  },
  setDeliveryDays: (days: number | null | undefined) => {
    set(() => ({
      deliveryDays: days,
    }))
  },
  setPricesIncludeTax: (pricesIncludeTax: boolean) => {
    set(() => ({
      pricesIncludeTax,
    }))
  },
  setFreeShippingRates: (rates: FreeShippingRate[]) => {
    set(() => ({
      freeShippingRates: rates,
    }))
  },
}))
